var _rect, _rect2, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileHashFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 1120,
    transform: "translate(-570 -125)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#FFF4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 45C43 42.2656 45.1875 40 48 40H60.5V50C60.5 51.4062 61.5938 52.5 63 52.5H73V55.5469C67.2188 57.1875 63 62.5 63 68.75C63 73.4375 65.2656 77.5 68.7031 80C68.4688 80 68.2344 80 68 80H48C45.1875 80 43 77.8125 43 75V45ZM63 50V40L73 50H63ZM65.5 68.75C65.5 62.5781 70.5 57.5 76.75 57.5C82.9219 57.5 88 62.5781 88 68.75C88 75 82.9219 80 76.75 80C70.5 80 65.5 75 65.5 68.75ZM76.75 76.25C77.7656 76.25 78.625 75.4688 78.625 74.375C78.625 73.3594 77.7656 72.5 76.75 72.5C75.6562 72.5 74.875 73.3594 74.875 74.375C74.875 75.4688 75.6562 76.25 76.75 76.25ZM75.4219 62.5V68.75C75.4219 69.4531 76.0469 70 76.6719 70C77.375 70 77.9219 69.4531 77.9219 68.75V62.5C77.9219 61.875 77.375 61.25 76.6719 61.25C76.0469 61.25 75.4219 61.875 75.4219 62.5Z",
    fill: "#F96464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileHashFail);
export default __webpack_public_path__ + "static/media/file-hash-fail.e3ede832033359c6fc32ac9f5d63a459.svg";
export { ForwardRef as ReactComponent };